<template>
    <div class="map-footer">
        <div>

            <!-- toggle button -->

            <b-link class="customizer-toggle d-flex align-items-center justify-content-center btn-round"
                v-b-toggle.collapse-1 variant="pridamary">

                <b-button id="footer-button" variant="primary" class="btn-round">
                    <feather-icon icon="SettingsIcon" size="15" class="spinner" />
                </b-button>
            </b-link>



            <b-collapse id="collapse-1" class="mt-2">
                <div class="map-footer-content">

                    <footer-card 
                        title="Device Info" 
                        :elements="[
                            {title:'Name', value:deviceData.name},
                            {title:'Owner', value:deviceData.owner_name},
                            {title:'Contract', value:deviceData.contract_name},
                            {title:'Category', value:$t(deviceData.category)},
                            {title:'Weight', value:deviceData.weight}
                        ]"
                    />

                    <footer-card 
                        title="Route Info" 
                        :elements="[
                            {title:'Tolal Distance', value:data.totalDistance},
                            {title:'Start Moving Time', value:data.startMovingTime},
                        ]"
                    />

                    <footer-card
                        v-if="category == 'SWEEPER'" 
                        title="Sweep"
                        description="Distance in Kilometers"
                        :elements="[
                            {title:'Total', value:data.total_sweep_distance},
                            {title:'Planned', value:data.planned_sweep_distance},
                            {title:'In Plan', value:data.in_plan_sweep_distance},
                            {title:'Out Plan', value:data.out_plan_sweep_distance}
                        ]"
                        icon="/icons/sweep.svg"
                    />

                    <div class="footer-item" v-if="category == 'COMPACTOR'">

                        <b-card no-body :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'">
                            <b-card-body class="d-flex justify-content-between align-items-center">
                                <div class="truncate">

                                    <h2 class="mb-25 font-weight-bolder">
                                        {{ $t('PTO') }}
                                    </h2>
                                    <span class="center-text">{{ data.pto }}</span>
                                </div>

                                <b-avatar variant="light-success" size="45">
                                    <feather-icon size="21" icon="InfoIcon" />
                                </b-avatar>
                            </b-card-body>
                        </b-card>
                    </div>
                    <div class="footer-item" v-if="category == 'COMPACTOR'">

                        <b-card no-body :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'">
                            <b-card-body class="d-flex justify-content-between align-items-center">
                                <div class="truncate">

                                    <h2 class="mb-25 font-weight-bolder">
                                        {{ $t('RFID') }}
                                    </h2>
                                    <span class="center-text">{{ data.rfid }}</span>
                                </div>

                                <b-avatar variant="light-success" size="45">
                                    <feather-icon size="21" icon="InfoIcon" />
                                </b-avatar>
                            </b-card-body>
                        </b-card>
                    </div>





                </div>
            </b-collapse>
        </div>
    </div>
</template>



<script>
import {
    BLink, BFormRadioGroup, BFormGroup, BFormCheckbox, BCard, BCardText, BRow,
    BCol, BCollapse, BButton, VBToggle, BCardBody,
    BAvatar,
} from 'bootstrap-vue'

import FooterCard from './FooterCard.vue';
import { title } from '@/@core/utils/filter';
export default {
    name: 'RouteFooter',
    components: {
        BLink, BFormRadioGroup, BFormGroup, BFormCheckbox, BCard, BCardText, BRow,
        BCol, BCollapse, BButton, VBToggle, BCardBody,
        BAvatar, FooterCard
    },
    props: {
        category: {
            type: String,
            default: ""
        },
        data: {
            type: Object,

        },
        deviceData: {
            type: Object
        }
    },
    directives: {
        'b-toggle': VBToggle,

    },
    setup(props){

        console.log(props.deviceData)
        return {}
    }

   
}
</script>

<style  lang="scss" scoped>

.footer-item > .card {
  margin-bottom: 0px !important;
}
.map-footer {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    z-index: 999;
}

.map-footer>.card {
    margin-bottom: 3px !important;
}

.map-footer-content {
    // background-color:rgba(255, 255, 255, 0.7);
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-right: 1rem;
    margin-left: 1rem;
    margin-bottom: 0.5rem
}

.footer-item {
    flex-basis: 291px;
    flex-grow: 1;
}

.footer-item>.card {
    margin-bottom: 0px !important;
    height: 100%;
}

#collapse-1 {
    margin-top: 0px !important;
}

#footer-button {
    border-radius: 18px 17px 0px 0px !important;
    padding: 9px !important;
}
</style>

